import React from 'react';
import {
  Box,
  Chip,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from "react-i18next";

const SuggestedQuestions = ({ questions, onQuestionClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      <Typography 
        variant="caption"
        sx={{ 
          fontSize: { md: '0.75rem', xs: '0.7rem' },
          fontWeight: 500,
          mb: 1,
          display: 'block',
          color: "white"
        }}
      >
        {t("suggestedQuestions")}:
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: 1,
        alignItems: 'flex-start'
      }}>
        {questions.map((question, index) => (
          <Chip
            key={index}
            label={question}
            variant="outlined"
            size={isMobile ? "small" : "medium"}
            onClick={() => onQuestionClick(question)}
            sx={{
              cursor: 'pointer',
              borderColor: theme.palette.primary.light,
              color: theme.palette.primary.main,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              fontSize: { md: '0.75rem', xs: '0.7rem' },
              height: 'auto',
              minHeight: { md: '32px', xs: '28px' },
              padding: { md: '4px 8px', xs: '2px 6px' },
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                lineHeight: '1.2',
                padding: 0,
              },
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: theme.palette.primary.light,
                color: "white",
                borderColor: theme.palette.primary.main,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[2],
              },
              '&:active': {
                transform: 'translateY(0px)',
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SuggestedQuestions; 